import axios from "axios";

const baseUrl = "https://services.postcodeanywhere.co.uk/Capture/Interactive";
const findURL = baseUrl + "/Find/v1.00/json3.ws";
const retrieveURL = baseUrl + "/Retrieve/v1.00/json3.ws";

export function pcaFind(countryCode, searchTerm, id) {
  return axios({
    method: "get",
    url: findURL,
    params: {
      Key: process.env.REACT_APP_PCA_PREDICT_KEY,
      Countries: countryCode,
      Text: searchTerm,
      Container: id,
      Limit: 50,
    },
  }).then((response) => {
    const { Items } = response.data;
    if (Items.length === 1 && typeof Items[0].Error !== "undefined") {
      return Promise.reject(new Error(Items[0].Description));
    } else {
      if (Items.length === 0) {
        return [];
      } else {
        return Items;
      }
    }
  });
}

export function pcaRetrieve(id) {
  return axios({
    method: "get",
    url: retrieveURL,
    params: {
      Key: process.env.REACT_APP_PCA_PREDICT_KEY,
      Id: id,
    },
  }).then((response) => {
    const { Items } = response.data;
    if (Items.length === 1 && typeof Items[0].Error !== "undefined") {
      return Promise.reject(new Error(Items[0].Description));
    } else {
      if (Items.length === 0) {
        return null;
      } else {
        return Items[0];
      }
    }
  });
}

export function pcaValidatePhone({ phone = "", country = "GB" }) {
  return axios({
    method: "get",
    url: `https://services.postcodeanywhere.co.uk/PhoneNumberValidation/Interactive/Validate/v2.20/json3.ws`,
    params: {
      Key: process.env.REACT_APP_PCA_PREDICT_KEY,
      Phone: phone,
      Country: country,
    },
  })
    .then((response) => {
      const { Items } = response.data;
      if (
        (Items.length === 1 && typeof Items[0].Error !== "undefined") ||
        Items.length === 0
      ) {
        return { isValid: false };
      } else {
        const item = Items[0] || {};
        return {
          isValid: item.IsValid === "Yes",
          numberType: item.NumberType,
          PhoneNumber: item.PhoneNumber,
          CountryPrefix: item.CountryPrefix,
        };
      }
    })
    .catch(() => {
      return { isValid: false };
    });
}
